<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
    name: 'App',
    data() {
      return {
        title: 'Golden Race Foundation',
        url: 'https://goldenrace.foundation',
        img: './assets/images/goldenrace-foundation.jpg',
        description: 'The Golden Race Foundation started in 2015 in the form of a Corporate Direct Giving Programme. We help children in developing countries during their educational period, giving them the tools to stand and change their future.'
      }
    },
    metaInfo() {
      return {
        // if no subcomponents specify a metaInfo.title, this title will be used
        title: 'Golden Race Foundation',
        /*
        meta: [
          { charset: 'utf-8' },

          { property: 'og:site_name', content: this.title },

          { property: 'og:title', content: this.title },
          { napropertyme: 'twitter:title', content: this.title },

          { name: 'description', content: this.description },
          { property: 'og:description', content: this.description },
          { property: 'twitter:description', content: this.description },

          { property: 'og:url', content: this.url },
          { property: 'twitter:url', content: this.url },

          { property: 'og:image', name: 'image', content: this.img },
          { property: 'og:image:secure_url', content: this.img },
          { property: 'twitter:image', content: this.img },
          { property: 'twitter:card', content: this.img },

          { name: 'viewport', content: 'width=device-width, initial-scale=1' }
        ]
        */
      }
    }
}
</script>